import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';


/* -------- packages -------- */
import * as Yup from "yup";
import {  Card, CardBody, CardFooter, Col, Container, Form, Input, Label, Modal, ModalBody, ModalHeader, Row, Spinner} from "reactstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Formik, useFormik } from "formik";
import { checkConfigurationRequest, duplicateConfigurationRequest, updateConfigurationRequest } from "../../../store/actions";
import { cancel } from "redux-saga/effects";
import { useNavigate } from "react-router-dom";
/* -------- ------- -------- */

export default function IntensityModal ({ isModalOpen, setModalOpen, config, isConfig = false }){
    const { t } = useTranslation();
    const parameters = useSelector(state => state.Parameters);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { loadingConfig } = useSelector(state => state.Configurations);

    const [navigateToConfig, setNavigateToConfig] = useState(false);

    const powerSupplyIntensity = config?.powerSupplyIntensity;
    const powerSupply = config?.powerSupply;

    
    const intensityForm = useFormik({
      enableReinitialize: true,
      
      initialValues: {
        isCircuitBreakerAdded: null,
        cancel: null,
      },
      validationSchema: Yup.object({
        isCircuitBreakerAdded: Yup.boolean(),
        cancel: Yup.boolean().required(),
      }),
      onSubmit: (values) => {

        if (values.cancel) {
          return window.location.reload();
        }
        
        const obj = {
          ...config,
          isCircuitBreakerAdded: values.isCircuitBreakerAdded,
        }

        if (isConfig) {
          return dispatch(checkConfigurationRequest(obj));
        } else if (navigateToConfig && !isConfig) {
          return dispatch(updateConfigurationRequest(obj, navigate, navigateToConfig));
        } else {
          return dispatch(updateConfigurationRequest(obj, navigate));
        }
      },
    });
    
    useEffect( () => { // Reset form values when modal opens
      if (isModalOpen) {
        intensityForm.setFieldValue('isCircuitBreakerAdded', null);
        intensityForm.setFieldValue('cancel', null);
      }
    }, [isModalOpen])

    return (
      <Modal isOpen={isModalOpen} toggle={() => setModalOpen(!isModalOpen)} centered={true} size={'xl'} scrollable={true} className="newProjectModal">
        <ModalHeader toggle={() => setModalOpen(false)}>{`${t('maximumIntensityExceeded')}`}</ModalHeader>
          <ModalBody className="">
            <Container>
              <Card className="">
                <CardBody className="newProjectBody">
                    <Row className="w-100 d-flex flex-column align-items-center justify-content-center">
                      <Col xs={12} className="m-0">
                        <Row className="w-100 d-flex flex-row justify-content-between mb-2 text-center">
                          <p className="text-muted font-size-16 mb-4">{t('maximumIntensityQuestion')}</p>
                        </Row>
                        <Row className="w-100 d-flex flex-row justify-content-start align-items-center mb-2 flex-wrap">
                          <span className="d-flex align-items-center justify-content-center w-auto me-2">
                            <Input
                              type="checkbox"
                              className='rights-checkbox'
                              id={`isCircuitBreakerAddedOption1`}
                              name={`isCircuitBreakerAddedOption1Input`}
                              onChange={() => {
                                intensityForm.setFieldValue('isCircuitBreakerAdded', true);
                                intensityForm.setFieldValue('cancel', false);
                              }}
                              checked={intensityForm.values.isCircuitBreakerAdded === true}
                              disabled={false}
                              />
                            </span>
                            { (powerSupply == "Alimentation MONO") ?
                              <Label className="w-75 p-2 m-0 text-wrap">{
                                (powerSupplyIntensity == "63A") ? 
                                t('maximumIntensityOption63_Mono') : t('maximumIntensityOption40_Mono')}
                              </Label>
                              :
                              <Label className="w-75 p-2 m-0 text-wrap">{
                                (powerSupplyIntensity == "63A") ? 
                                t('maximumIntensityOption63_Tetra') : t('maximumIntensityOption40_Tetra')}
                              </Label>
                            }
                        </Row>
                        <Row className="w-100 d-flex flex-row justify-content-start align-items-center mb-2 flex-wrap text-wrap">
                          <span className="d-flex align-items-center justify-content-center w-auto me-2">
                            <Input
                              type="checkbox"
                              className='rights-checkbox'
                              id={`isCircuitBreakerAddedOption2`}
                              name={`isCircuitBreakerAddedOption2Input`}
                              onChange={() => {
                                intensityForm.setFieldValue('isCircuitBreakerAdded', false);
                                intensityForm.setFieldValue('cancel', false);
                              }}
                              checked={intensityForm.values.isCircuitBreakerAdded == false}
                              disabled={false}
                              />
                            </span>
                          <Label className="w-75 p-2 m-0 text-wrap">{t('maximumIntensityOption2')}</Label>
                        </Row>
                        <Row className="w-100 d-flex flex-row justify-content-start align-items-center mb-2 flex-wrap">
                          <span className="d-flex align-items-center justify-content-center w-auto me-2">
                            <Input
                              type="checkbox"
                              className='rights-checkbox'
                              id={`isCircuitBreakerAddedCancel`}
                              name={`isCircuitBreakerAddedCancelInput`}
                              onChange={() => {
                                intensityForm.setFieldValue('isCircuitBreakerAdded', undefined);
                                intensityForm.setFieldValue('cancel', true);
                              }}
                              checked={intensityForm.values.cancel === true}
                              disabled={false}
                              />
                            </span>
                          <Label className="w-75 p-2 m-0">{t('cancel')}</Label>
                        </Row>
                      </Col>
                    </Row>
                </CardBody>
                    <CardFooter>
                    {!isConfig ? 
                      <>
                        <button type="button" className="btn btn-secondary" onClick={() => {setModalOpen(false); window.location.reload();}} disabled={loadingConfig}>{t('close')}</button>
                        <button type="submit" onClick={() => {setNavigateToConfig(false); intensityForm.handleSubmit(); setModalOpen(false)}} className="btn btn-primary">
                          {
                            loadingConfig ?
                            <>
                            <Spinner size="sm"/>
                          </>
                          : 
                          t('validate')
                        }
                          </button>
                        <button type="submit" onClick={() => {setNavigateToConfig(true); intensityForm.handleSubmit()}} className="btn btn-primary">
                          {
                            loadingConfig ?
                            <>
                            <Spinner size="sm"/>
                          </>
                          : 
                          t('submitAndNavigateConfig')
                        }
                        </button>
                      </>

                      : 

                      <>
                        <button type="button" className="btn btn-secondary" onClick={() => {setModalOpen(false); window.location.reload();}} disabled={loadingConfig}>{t('close')}</button>
                        <button type="submit" onClick={() => {setNavigateToConfig(false); intensityForm.handleSubmit(); setModalOpen(false)}} className="btn btn-primary">
                          {
                            loadingConfig ?
                            <>
                            <Spinner size="sm"/>
                          </>
                          : 
                          t('validate')
                        }
                          </button>
                      </>
                    }
                    </CardFooter>
                </Card>
            </Container>
          </ModalBody>
      </Modal>
    );
};